import { render, staticRenderFns } from "./drawerTable.vue?vue&type=template&id=221a4c64&scoped=true&"
import script from "./drawerTable.vue?vue&type=script&lang=js&"
export * from "./drawerTable.vue?vue&type=script&lang=js&"
import style0 from "./drawerTable.vue?vue&type=style&index=0&id=221a4c64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a4c64",
  null
  
)

export default component.exports